// extracted by mini-css-extract-plugin
module.exports = {"edit":"edit--1VUfB","btns":"btns--165w5","saveBtn":"saveBtn--1mol-","boxTitle":"boxTitle--3B_1r","info":"info--33gcA","high":"high--1txJv"};